import { render, staticRenderFns } from "./DadosEmbalagem.vue?vue&type=template&id=4fb41df6"
import script from "./DadosEmbalagem.vue?vue&type=script&lang=js"
export * from "./DadosEmbalagem.vue?vue&type=script&lang=js"
import style0 from "./DadosEmbalagem.vue?vue&type=style&index=0&id=4fb41df6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports